<template>
	<div class="gradtime-wrap">
    <div class="gradtime-input">
			<!-- 日期展示 -->
			<div class="gradtime-info" @click="showPopup">
				<a class="gradtime-placeholder"
					:class="{'gradtime-placeholder-tip': showTip}">
					{{timeTip}}
				</a>
				<span class="gradtime-time"
					:class="{'gradtime-time-tip': showTip}">
					{{time}}
				</span>
			</div>
    </div>
		<!-- 日期选择控件 -->
		<popup v-model="showBox">
			<div class="popup-box">
				<div class="popup-title">
					<span class="title">{{DateObj.title}}</span>
					<span class="btn" @click="finishSelect">{{DateObj.btnText}}</span>
				</div>
        <div class="popup-main">
          <select-scroll
						v-for="(item, index) in DateArray"
						:key="index"
						:dataList="item.list"
						:selectedIndex="item.selectedIndex"
						:show="showBox"
						:scrollIndex="index"
						@scrollEnd="scrollEnd">
					</select-scroll>
        </div>
			</div>
		</popup>
	</div>
</template>

<script>
import * as types from '../../../../store/mutation-types';
import { Popup } from '@58fe/v5';
import selectScroll from '../../../common/selectScroll';
import config from '../../../../util/config';
import { mapGetters } from 'vuex';
export default {
	data() {
		return {
			showBox: false, // 日期控件展示标志
			showTip: false, // 显示提示信息
			time: '', // 当前选中的日期
			timeTip: '毕业时间', // 提示信息
			DateObj: {
				title: '请选择您毕业的时间',
				btnText: '确定',
				selectedText: '请选择'
			},
			DateArray: [
				{
					selectedIndex: config.eduYearList.length - 1,
					list: ['', ''].concat(config.eduYearList).concat(['', ''])
				},
				{
					selectedIndex: 0,
					list: ['', ''].concat(config.eduMonthList).concat(['', ''])
				}
			]
		};
	},
	created() {
		if (this.pagefrom === 'fromCQXZ') {
			this.DateArray[0].selectedIndex = config.eduYearList.length - 6;  // 重庆校招毕业时间默认当年
		}
		// 日期初始化
		let originTime = this.gradtime.split('年');
		if (originTime.length > 1) {
			let yearIndex = config.eduYearList.findIndex(el => el === `${originTime[0]}年`);
			let monthIndex = config.eduMonthList.findIndex(el => el === originTime[1]);
			this.scrollEnd(yearIndex, 0);
			this.scrollEnd(monthIndex, 1);
			this.checkTime();
		}
	},
	watch: {
		gradtime(val) {
			this.time = val;
		},
		time(val) {
			this.showTip = !!val;
		}
	},
	methods: {
		/**
		 * 日期控件展示
		 */
		showPopup() {
			this.showBox = true;
			this.checkTime();
		},
		/**
		 * 滚动结束触发选择
		 */
		scrollEnd(select, index) {
			this.$set(this.DateArray[index], 'selectedIndex', select); // 更新选择项的index
			this.time = this.getTime;
			this.checkTime();
		},
		checkTime() {
			this.time = this.getTime;
			this.$store.commit(types.CHECK_EDUINFO, {
				key: 'gradtime',
				value: this.time,
				state: true
			});
		},
		/**
		 * 关闭控件
		 */
		finishSelect() {
			this.showBox = false;
		}
	},
	computed: {
		...mapGetters([
			'gradtime',
			'pagefrom'
		]),
		// 日期格式化
		getTime() {
			let yearIndex = this.DateArray[0].selectedIndex + 2,
				monthIndex = this.DateArray[1].selectedIndex + 2;
			return `${this.DateArray[0].list[yearIndex]}${this.DateArray[1].list[monthIndex]}`;
		}
	},
	components: {
		Popup,
		selectScroll
	}
};
</script>

<style lang="scss">
@import '../../../../assets/style/public.scss';
.gradtime-wrap {
	.gradtime-info {
		position: relative;
		margin: 0 px2rem(30px);
		padding: 0;
		height: px2rem(138px);
		line-height: px2rem(138px);
		border-bottom: 1px solid #f3f3f3;
		color: #999;
		font-size: px2rem(38px);
		text-align: center;
	}
	.gradtime-placeholder {
		position: absolute;
		left: 0;
		right: 0;
		text-align: center;
		&.gradtime-placeholder-tip {
			position: relative;
			display: block;
			margin: auto;
			padding-top: px2rem(24px);
			font-size: px2rem(24px);
			line-height: px2rem(38px);
			color: #ccc;
			transition-property: font-size 0.1s linear;
		}
	}
	.gradtime-time {
		margin: 0 auto;
		width: px2rem(600px);
		height: px2rem(52px);
		line-height: px2rem(52px);
		font-size: px2rem(38px);
		color: #000;
		text-align: center;
		&.gradtime-time-tip {
			display: block;
		}
	}
  .popup-box {
    background: #fff;
	}
	.popup-main {
		margin: 0 px2rem(70px);
	}
	.popup-content {
    display: inline-block;
		margin: 0;
    width: 50%;
	}
}
</style>



// WEBPACK FOOTER //
// gradTime.vue?7165dd68